module.exports = __webpack_public_path__ + "img/bord.7a34817c.png";